
import { PostInterface } from "../../types/post/post-interface.interface";
import { createAction, props } from "@ngrx/store";

export const getPosts = createAction('[Posts] Get Posts',);
export const getPostsSuccess = createAction('[Posts] Get Posts success', props<{posts: PostInterface[] }>(), );
export const getPostsFailure = createAction('[Posts] Get Posts failure', props<{error: string}>());